import { render, staticRenderFns } from "./itemlist.vue?vue&type=template&id=975fcf5c&scoped=true"
import script from "./itemlist.vue?vue&type=script&lang=js"
export * from "./itemlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975fcf5c",
  null
  
)

export default component.exports